<div class="map-container" [class.new]="addTicketActive || editTicketActive">
  <div id="map" #map></div>
  <div class="map-add-button" [class.new]="addTicketActive" [class.edit]="editTicketActive" (click)="addNewOrEdit($event)"><mat-icon class="material-icons-outlined">{{arcgisMapService.clickedFeature.value && !arcgisMapService.clickedFeature.value.objectId ? 'edit' : 'add' }}</mat-icon></div>
</div>
